import type { IViewSnapshotState } from "@multiconsult-group/multiplacer-core";
import { viewerViewFingerprint } from "../viewerViewFingerprint";

export const sharedViewPath = (projectNo: number, stateId: string) =>
  `/${projectNo}/design?${new URLSearchParams({ state: stateId })}`;

// Ignore sub-millimetre camera noise and selection ordering, not actual view changes.
export const sharedViewFingerprint = ({ view, context }: IViewSnapshotState): string => JSON.stringify({
  view: viewerViewFingerprint(view),
  context: {
    ...context,
    selectedSpaceNumber: context.selectedSpaceNumber ?? null,
    camera: {
      rotation: context.camera.rotation,
      zoom: Math.round(context.camera.zoom * 1000) / 1000,
      centerWorld: {
        x: Math.round(context.camera.centerWorld.x * 1000) / 1000,
        y: Math.round(context.camera.centerWorld.y * 1000) / 1000,
      },
    },
  },
});

export const basicViewSearchParams = ({ context }: IViewSnapshotState) => {
  const params = new URLSearchParams({
    module: context.module,
    floor: context.floorName,
    building: context.building,
    rot: String(context.camera.rotation),
    z: String(context.camera.zoom),
    p: `${context.camera.centerWorld.x},${context.camera.centerWorld.y}`,
  });
  if (context.selectedSpaceNumber) params.set("room", context.selectedSpaceNumber);
  return params;
};
